import { createSlice } from "@reduxjs/toolkit";
import { fetchGroups } from "./groupsThunks";

const initialState = {
  groups: [],
  filterSearch:null,
  status: "idle",
  error: null,
};

const groupsSlice = createSlice({
  name: "groups",
  initialState,
  reducers: {
    setSearch: (state, action) => {
      state.filterSearch = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGroups.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchGroups.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.groups = action.payload;
      })
      .addCase(fetchGroups.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});
export const { 
 setSearch
} = groupsSlice.actions;
// ✅ correct: export reducer only
export default groupsSlice.reducer;
